const LocalEventDetails = [
 
  {
    id: 1,
    title: "Seth Wisdom Workshop by Bala Krishna Sir",
    img: require("./images/SETH_WorkshopGroupPhoto.jpeg"),
  },
  
];

const USA_EventDetails = [
  {
    id: 1,
    title: "Mega Meditation Summit (Dhyanma Maha Chakram) @ Dallas",
    img: require("./images/MMS_Event.jpeg"),
  },
  {
    id: 2,
    title: "Pyramid Bhumi Pooja @ Raliegh",
    img: require("./images/RaleighFirstPyramidLayingStone.jpg"),
  },
  {
    id: 3,
    title: "Patriji Amruthosthav @ Maryland",
    img: require("./images/DMMS_Dallas.jpg"),
  },
];

export { LocalEventDetails, USA_EventDetails };
